import { createActions } from 'redux-actions';

import types from 'state/mrDistribution/repeated-from/actionTypes';

const { mrDistribution } = createActions({
  [types.SET_REPEATED_FROM]: ({ orderId }) => ({ orderId }),
});

export default mrDistribution;
